import { render } from "./Recibos.vue?vue&type=template&id=9785e262&scoped=true"
import script from "./Recibos.vue?vue&type=script&lang=js"
export * from "./Recibos.vue?vue&type=script&lang=js"

import "./Recibos.vue?vue&type=style&index=0&id=9785e262&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9785e262"]])

export default __exports__